module.exports = __webpack_public_path__ + "img/beach-built-hiit-classes.535b1dba.jpg";